import React from "react";
import "./ChoosePropertiesNew.css";

/* Crisp Vector Icons matching Reference Image */
const HeadphoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
);

const AdminIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <circle cx="19" cy="11" r="2" />
    <path d="M19 8v1m0 4v1m-3-3h1m4 0h1" />
  </svg>
);

const MobileFriendlyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="13" height="17" rx="2" />
    <rect x="9" y="8" width="13" height="13" rx="2" />
    <path d="M15 18h.01" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const HomeBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const CurvedArrow = () => (
  <svg width="45" height="45" viewBox="0 0 50 50" fill="none" stroke="#d48b1d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M36 8 C 22 14, 14 28, 24 42" />
    <polyline points="18 40 24 42 26 35" />
  </svg>
);

const DotGrid = ({ count = 25 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="wcp-dot" />
    ))}
  </>
);

const ChooseProperties = () => {
  return (
    <section className="wcp-section-container">
      <div className="wcp-inner-container">
        <div className="wcp-grid-wrap">
          {/* =================================================================
              Left Column: Titles & 3 Feature Cards
              ================================================================= */}
          <div className="wcp-left-col">
           

            {/* Main Title */}
            <h2 className="wcp-main-title">
              <span className="wcp-title-dark">Why Choose </span>
              <span className="wcp-title-gold">Our Properties</span>
            </h2>

            {/* Sub-description */}
            <p className="wcp-sub-desc">
              We make property buying, selling and renting simple, transparent
              and hassle-free for everyone in Hyderabad.
            </p>

            {/* Feature Cards Stack */}
            <div className="wcp-cards-stack">
              {/* Card 1: 24 Hours Support */}
              <div className="wcp-feature-card">
                <div className="wcp-icon-box wcp-icon-gold">
                  <HeadphoneIcon />
                </div>
                <div className="wcp-card-text">
                  <h3>24 Hours Support</h3>
                  <p>
                    Offering 24-hour support for a property website is an
                    indispensable asset that establishes trust and reliability.
                  </p>
                </div>
                <div className="wcp-card-action wcp-action-gold">
                  <ChevronRightIcon />
                </div>
              </div>

              {/* Card 2: User Admin Panel */}
              <div className="wcp-feature-card">
                <div className="wcp-icon-box wcp-icon-blue">
                  <AdminIcon />
                </div>
                <div className="wcp-card-text">
                  <h3>User Admin Panel</h3>
                  <p>
                    The user admin panel is the control center of our property
                    website, granting users an intuitive interface to manage
                    listings, preferences, and interactions.
                  </p>
                </div>
                <div className="wcp-card-action wcp-action-blue">
                  <ChevronRightIcon />
                </div>
              </div>

              {/* Card 3: Mobile Friendly */}
              <div className="wcp-feature-card">
                <div className="wcp-icon-box wcp-icon-coral">
                  <MobileFriendlyIcon />
                </div>
                <div className="wcp-card-text">
                  <h3>Mobile Friendly</h3>
                  <p>
                    Our property website is meticulously crafted to be
                    mobile-friendly, ensuring a seamless browsing experience
                    across all devices.
                  </p>
                </div>
                <div className="wcp-card-action wcp-action-coral">
                  <ChevronRightIcon />
                </div>
              </div>
            </div>
          </div>

          {/* =================================================================
              Right Column: Main Image & Floating Badges
              ================================================================= */}
          <div className="wcp-right-col">
            {/* Organic Background Shape Blob */}
            <div className="wcp-bg-blob" />

            {/* Dot Grids */}
            <div className="wcp-dot-grid-top-right">
              <DotGrid count={25} />
            </div>
            <div className="wcp-dot-grid-bottom-left">
              <DotGrid count={25} />
            </div>

            {/* Main Image */}
            <div className="wcp-image-wrap">
              <img
                src="/assets/images/why_choose_villa.jpg"
                alt="Luxury Modern Living Room"
                className="wcp-main-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/assets/images/all/27.jpg";
                }}
              />

              {/* Floating Badge 1: Top-Right "Trusted by Happy Customers" */}
              <div className="wcp-floating-badge">
                <div className="wcp-badge-icon-box">
                  <HomeBadgeIcon />
                </div>
                <div className="wcp-badge-text-box">
                  <span className="wcp-badge-label">Trusted by</span>
                  <span className="wcp-badge-title">Happy Customers</span>
                </div>
              </div>

              {/* Hand-drawn curved arrow below top badge */}
              <div className="wcp-arrow-wrap">
                <CurvedArrow />
              </div>

              {/* Floating Testimonial Card: Bottom-Right with Mr. Govind */}
              <div className="wcp-testimonial-card">
                <div className="wcp-quote-mark">“</div>
                <p className="wcp-testimonial-quote">
                  Your website is fully responsive so visitors can view your
                  content from their choice of device.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseProperties;
